@if (features?.classifications.length > 0 || (agecLaw && activeAgecLaw)) {
  @let _brand = brand();
  @let _isInsideSection = isInsideSection();

  <sd-component-wrapper
    id="{{ componentId }}"
    [content]="wrapperContent"
    [themesConfig]="lameConfig?.backgroundTheme"
    [brand]="_brand"
    [marginSize]="_isInsideSection ? MarginEnum.without_margin : MarginEnum.default_margin"
    [componentWidth]="_isInsideSection ? ComponentWrapperWidthEnum.absoluteFullWidth : ComponentWrapperWidthEnum.default"
  >
    <ng-container sd-component-wrapper-component>
      @if (activeAgecLaw) {
        @if (_isInsideSection && showFeaturesTab) {
          <sd-table-features [features]="features" />
        } @else if (!_isInsideSection) {
          @if (agecLaw) {
            <aside>
              <ng-container>
                <sd-table-features [isOpen]="true" [features]="featuresAgecLaw" />
              </ng-container>

              @if (substanceProducts.length > 0) {
                <sd-table-features [isOpen]="false" [features]="featuresSubstance" />
              }
            </aside>
          } @else {
            <p>{{ 'pdp.characteristicstable.tab.environnement.nodata' | translate }}</p>
          }
        }
      } @else if (_isInsideSection) {
        <sd-table-features [features]="features" />
      }
    </ng-container>
  </sd-component-wrapper>
}
